import {
  grayColor,
  roseColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  PrimaryButtonColor,
  SecondaryButtonColor
}  from "./material-kit-react.js"

const buttonStyle = {
  button: {
    minHeight: "auto",
    minWidth: "auto",
    backgroundColor: grayColor,
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    position: "relative",
    padding: "12px 30px",
    margin: ".3125rem 1px",
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    letterSpacing: "0",
    transition: "all 0.2s ease",
    lineHeight: "1.42857143",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    touchAction: "manipulation",
    cursor: "pointer",
    "&:hover,&:focus": {
      color: "#ffffff",
      backgroundColor: grayColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      display: "inline-block",
      top: "0",
      fontSize: "1.1rem",
      marginRight: "4px",
      verticalAlign: "middle"
    },
    "& svg": {
      position: "relative",
      display: "inline-block",
      top: "0",
      width: "18px",
      height: "18px",
      marginRight: "4px",
      verticalAlign: "middle"
    },
    "&$justIcon": {
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
        marginRight: "0px",
        position: "absolute",
        width: "100%",
        transform: "none",
        left: "0px",
        top: "0px",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px"
      }
    }
  },
  fullWidth: {
    width: "100%"
  },
  primary: {
    backgroundColor: primaryColor,
    color: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: primaryColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  info: {
    backgroundColor: infoColor,
    color: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: infoColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  success: {
    backgroundColor: successColor,
    color: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: successColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  warning: {
    backgroundColor: warningColor,
    color: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: warningColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  danger: {
    backgroundColor: dangerColor,
    color: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: dangerColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  rose: {
    backgroundColor: roseColor,
    color: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: roseColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  white: {
    "&,&:focus,&:hover,&:visited": {
      backgroundColor: "#ffffff",
      color: grayColor,
      border: `1px solid ${grayColor}`
    }
  },
  twitter: {
    backgroundColor: primaryColor,
    color: "#fff",
    "&:hover,&:focus,&:visited": {
      backgroundColor: primaryColor,
      color: "#fff",
      opacity: 0.9
    }
  },
  facebook: {
    backgroundColor: primaryColor,
    color: "#fff",
    "&:hover,&:focus": {
      backgroundColor: primaryColor,
      color: "#fff",
      opacity: 0.9
    }
  },
  google: {
    backgroundColor: primaryColor,
    color: "#fff",
    "&:hover,&:focus": {
      backgroundColor: primaryColor,
      color: "#fff",
      opacity: 0.9
    }
  },
  github: {
    backgroundColor: "#333333",
    color: "#fff",
    "&:hover,&:focus": {
      backgroundColor: "#333333",
      color: "#fff",
      opacity: 0.9
    }
  },
  primaryButton: {
    backgroundColor: PrimaryButtonColor,
    color: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: PrimaryButtonColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  secondaryButton: {
    backgroundColor: SecondaryButtonColor,
    color: "#080C14",
    "&:hover,&:focus": {
      backgroundColor: SecondaryButtonColor,
      opacity: 0.9,
      transform: "translateY(-1px)"
    }
  },
  simple: {
    "&,&:focus,&:hover,&:visited": {
      color: "#ffffff",
      background: "transparent",
      boxShadow: "none"
    },
    "&$primary": {
      "&,&:focus,&:hover,&:visited": {
        color: primaryColor
      }
    },
    "&$info": {
      "&,&:focus,&:hover,&:visited": {
        color: infoColor
      }
    },
    "&$success": {
      "&,&:focus,&:hover,&:visited": {
        color: successColor
      }
    },
    "&$warning": {
      "&,&:focus,&:hover,&:visited": {
        color: warningColor
      }
    },
    "&$rose": {
      "&,&:focus,&:hover,&:visited": {
        color: roseColor
      }
    },
    "&$danger": {
      "&,&:focus,&:hover,&:visited": {
        color: dangerColor
      }
    },
    "&$twitter": {
      "&,&:focus,&:hover,&:visited": {
        color: primaryColor
      }
    },
    "&$facebook": {
      "&,&:focus,&:hover,&:visited": {
        color: primaryColor
      }
    },
    "&$google": {
      "&,&:focus,&:hover,&:visited": {
        color: primaryColor
      }
    },
    "&$github": {
      "&,&:focus,&:hover,&:visited": {
        color: "#333333"
      }
    }
  },
  transparent: {
    "&,&:focus,&:hover,&:visited": {
      color: "inherit",
      background: "transparent",
      boxShadow: "none"
    }
  },
  disabled: {
    opacity: "0.65",
    pointerEvents: "none"
  },
  lg: {
    padding: "1.125rem 2.25rem",
    fontSize: "0.875rem",
    lineHeight: "1.333333",
    borderRadius: "8px"
  },
  sm: {
    padding: "0.40625rem 1.25rem",
    fontSize: "0.6875rem",
    lineHeight: "1.5",
    borderRadius: "8px"
  },
  round: {
    borderRadius: "30px"
  },
  block: {
    width: "100% !important"
  },
  link: {
    "&,&:hover,&:focus": {
      backgroundColor: "transparent",
      color: primaryColor,
      boxShadow: "none"
    }
  },
  justIcon: {
    paddingLeft: "12px",
    paddingRight: "12px",
    fontSize: "20px",
    height: "41px",
    minWidth: "41px",
    width: "41px",
    "& .fab,& .fas,& .far,& .fal,& svg,& .material-icons": {
      marginRight: "0px"
    },
    "&$lg": {
      height: "57px",
      minWidth: "57px",
      width: "57px",
      lineHeight: "56px",
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
        fontSize: "32px",
        lineHeight: "56px"
      },
      "& svg": {
        width: "32px",
        height: "32px"
      }
    },
    "&$sm": {
      height: "30px",
      minWidth: "30px",
      width: "30px",
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
        fontSize: "17px",
        lineHeight: "29px"
      },
      "& svg": {
        width: "17px",
        height: "17px"
      }
    }
  }
};

export default buttonStyle;
